(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); this.setHeaderHeight = this.setHeaderHeight.bind(this); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() { this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight); this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() { const observer = new IntersectionObserver((entries) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); }); observer.observe(this.header); }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); }
      } else if (scrollTop <= this.headerBounds.top) { this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this)); }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((disclosure) => disclosure.close()); }
    closeSearchModal() { this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal'); this.searchModals.forEach((searchModal) => searchModal.close(false)); }
  }

  document.addEventListener('open', (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
    const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
    event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
  }, true);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharp-custom-landing"] && !Shopify.designMode) return;
  try {
    
  const customPages = document.querySelectorAll('[data-sharp-custom-page]');

  customPages.forEach((page) => {
    const search = page.querySelector('[data-sharp-team-search]');
    const cards = Array.from(page.querySelectorAll('[data-sharp-team-card]'));
    const empty = page.querySelector('[data-sharp-team-empty]');

    if (search && !search.dataset.sharpReady) {
      search.dataset.sharpReady = 'true';
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        let visible = 0;

        cards.forEach((card) => {
          const name = card.dataset.teamName || '';
          const match = !query || name.includes(query);
          card.hidden = !match;
          if (match) visible += 1;
        });

        if (empty) empty.hidden = visible !== 0;
      });
    }

    const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) {
      page.querySelectorAll('[data-sharp-preview-link]').forEach((link) => {
        try {
          const target = new URL(link.getAttribute('href'), window.location.origin);
          target.searchParams.set('preview_theme_id', previewId);
          link.setAttribute('href', target.pathname + target.search + target.hash);
        } catch (error) {
          /* Keep the original storefront URL if parsing fails. */
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharp-custom-only"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sharp-custom]').forEach((section) => {
    const dialog = section.querySelector('[data-sharp-inquiry-dialog]');
    const openers = section.querySelectorAll('[data-sharp-inquiry-open]');
    const close = section.querySelector('[data-sharp-inquiry-close]');
    const sportInputs = Array.from(section.querySelectorAll('[data-sharp-sport-option]'));
    const sportSummary = section.querySelector('[data-sharp-sports-summary]');

    const syncSports = () => {
      const selected = sportInputs.filter((input) => input.checked).map((input) => input.value);
      if (sportSummary) sportSummary.value = selected.join(', ');
      sportInputs.forEach((input, index) => { input.required = index === 0 && selected.length === 0; });
    };

    let lastOpener;
    let previousOverflow;
    const openDialog = (event) => {
      lastOpener = event?.currentTarget || lastOpener;
      const sport = event?.currentTarget?.dataset.sharpStartSport;
      if (sport) {
        sportInputs.forEach((input) => { if (input.value === sport) input.checked = true; });
        syncSports();
      }
      if (!dialog) return;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open','');
    };

    sportInputs.forEach((input) => input.addEventListener('change', syncSports));
    openers.forEach((button) => button.addEventListener('click', openDialog));
    close?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow || '';
      lastOpener?.focus();
    });
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    section.querySelector('form')?.addEventListener('submit', syncSports);
    syncSports();

    if (section.querySelector('.sharp-custom__notice')) openDialog();

    const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) {
      section.querySelectorAll('[data-sharp-preview-link]').forEach((link) => {
        try {
          const target = new URL(link.getAttribute('href'), window.location.origin);
          target.searchParams.set('preview_theme_id', previewId);
          link.setAttribute('href', target.pathname + target.search + target.hash);
        } catch (error) {}
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharp-shared-team-gear"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sharp-shared-team-gear')) {
    customElements.define('sharp-shared-team-gear', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharp-team-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sharp-team-preview')) {
    customElements.define('sharp-team-preview',class extends HTMLElement {
      connectedCallback() {
        this.onChange=event=>{
          if(event.target.matches('[data-preview-width]')) this.querySelector('[data-preview-frame]').dataset.width=event.target.value;
          if(event.target.matches('[data-preview-state]')) {
            this.querySelector('sharp-order-window').dispatchEvent(new CustomEvent('sharp:window-preview',{detail:event.target.value}));
            const key=event.target.value==='configured'?'[data-configured-note]':'[data-simulated-note]';
            this.querySelector('[data-preview-note]').textContent=this.querySelector(key).textContent;
          }
        };
        this.addEventListener('change',this.onChange);
      }
      disconnectedCallback(){this.removeEventListener('change',this.onChange);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharp-team-stores"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sharp-team-stores]').forEach((page) => {
    const search = page.querySelector('[data-sharp-team-search]');
    const clear = page.querySelector('[data-sharp-team-clear]');
    const dock = page.querySelector('[data-sharp-team-dock]');
    const cards = Array.from(page.querySelectorAll('[data-sharp-team-card]'));
    const empty = page.querySelector('[data-sharp-team-empty]');
    const count = page.querySelector('[data-sharp-team-count]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const dialog = page.querySelector('[data-sharp-team-store-dialog]');
    const dialogOpeners = page.querySelectorAll('[data-sharp-team-store-open]');
    const dialogClose = page.querySelector('[data-sharp-team-store-close]');

    const resetDock = () => cards.forEach((card) => {
      card.style.setProperty('--dock-scale','1');
      card.style.setProperty('--dock-lift','0px');
      card.style.setProperty('--dock-z','1');
      card.style.filter = '';
    });

    const update = () => {
      const normalize = (text) => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
      const query = normalize(search?.value || '');
      const words = query.split(/\s+/).filter(Boolean);
      let visible = 0;
      cards.forEach((card) => {
        const match = !query || words.every((word) => normalize(card.dataset.teamName || '').includes(word));
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (count) count.textContent = `${visible} ${visible === 1 ? 'team' : 'teams'}`;
      if (empty) empty.hidden = visible !== 0;
      if (clear) clear.hidden = !query;
      resetDock();
    };

    const openDialog = () => {
      if (!dialog || dialog.open) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open','');
    };

    search?.addEventListener('input', update);
    clear?.addEventListener('click', () => { search.value=''; update(); search.focus(); });
    search?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && search.value) {
        search.value = '';
        update();
      }
    });



    dialogOpeners.forEach((button) => button.addEventListener('click', openDialog));
    dialogClose?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    const openLinkedInquiry = () => {
      if (window.location.hash === '#start-a-team-store') openDialog();
    };
    window.addEventListener('hashchange', openLinkedInquiry);
    dialog?.addEventListener('close', () => {
      if (window.location.hash === '#start-a-team-store') {
        window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
      }
    });
    openLinkedInquiry();
    if (page.querySelector('.sharp-team-stores__notice')) openDialog();

    const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) {
      page.querySelectorAll('[data-sharp-preview-link]').forEach((link) => {
        try {
          const target = new URL(link.getAttribute('href'), window.location.origin);
          target.searchParams.set('preview_theme_id', previewId);
          link.setAttribute('href', target.pathname + target.search + target.hash);
        } catch (error) {}
      });
    }
    if (search) search.value = new URLSearchParams(window.location.search).get('q') || search.value;
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
